<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    :class="customStyle"
    enable-background="new 0 0 1000 1000"
    xml:space="preserve"
  >
    <g>
      <path
        d="M278.5,406l-67.1,67.1l248.4,255.1L990,224.8L922.9,151L459.7,587.3L278.5,406z"
      />
      <path
        d="M889.3,547C862.5,741.6,701.4,889.3,500,889.3c-214.8,0-396-174.5-396-396C104,271.8,285.2,104,500,104c67.1,0,134.2,20.1,194.7,53.7l73.8-73.8C687.9,36.8,600.7,10,500,10C231.5,10,10,224.8,10,500c0,275.2,221.5,490,490,490c255.1,0,463.2-194.7,490-443H889.3z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckCircleIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
